import { useCallback, useEffect, useRef, useState } from "react";

// TODO: Maybe we should implement this with zustand
// so we can also re-listen to it again
export default function usePromisifyValue(initialValue) {
  const [state, setState] = useState(initialValue);
  const resolveRef = useRef(null);

  const propertyName = Object.keys(initialValue)[0];

  useEffect(() => {
    if (state[propertyName] && resolveRef.current) {
      resolveRef.current(true);
      resolveRef.current = null;
    }
  }, [state, propertyName]);

  const getPromise = useCallback(() => {
    return new Promise((resolve) => {
      if (state[propertyName]) {
        resolve(true);
      } else {
        resolveRef.current = resolve;
      }
    });
  }, [state, propertyName]);

  const setValue = (newValue) => {
    setState((prev) => ({ ...prev, ...newValue }));
  };

  return [state, getPromise, setValue];
}
